// Internal DriverWatch Admin Portal - App Router
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import StaffManagement from "./pages/StaffManagement";
import FeatureRequests from "./pages/FeatureRequests";
import Tools from "./pages/Tools";

// ProtectedRoute checks if the internal user is logged in
function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem("internal_token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        <Route path="/users" element={
          <ProtectedRoute>
            <StaffManagement />
          </ProtectedRoute>
        } />

        <Route path="/feature-requests" element={
          <ProtectedRoute>
            <FeatureRequests />
          </ProtectedRoute>
        } />

        <Route path="/tools" element={
          <ProtectedRoute>
            <Tools />
          </ProtectedRoute>
        } />

      </Routes>
    </BrowserRouter>
  );
}

export default App;